module.exports = __webpack_public_path__ + "media/images/icons/SVG/065-8cc2cba9d2048c925a4f6676d5121afd.svg";